module.exports = __webpack_public_path__ + "static/promise-7d41c3ea903fa64d2c8923c2b859cd12.png";